import { render, staticRenderFns } from "./copyright-vincreative.vue?vue&type=template&id=fb400264&scoped=true"
import script from "./copyright-vincreative.vue?vue&type=script&lang=js"
export * from "./copyright-vincreative.vue?vue&type=script&lang=js"
import style0 from "./copyright-vincreative.vue?vue&type=style&index=0&id=fb400264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb400264",
  null
  
)

export default component.exports